<template>
  <div class="format-information">
    <custom-chip green-chip bold>
      <span>R$ {{ cashbackDiscount }} de Cashback</span>
    </custom-chip>
    <div class="d-flex flex-row align-center" style="gap: 16px">
      <span v-if="!isMobile" class="qty-per-client-text"><strong>Mín. CPF: </strong>{{ offer.minimum_per_client }}</span>
      <span v-if="offer.maximum_per_client && !isMobile" class="qty-per-client-text"><strong>Máx. CPF: </strong>{{ offer.maximum_per_client }}</span>
      <span v-else-if="offer.max_coupons && !isMobile" class="qty-per-client-text"><strong>Máx. ativação por CPF: </strong>{{ offer.max_coupons }}</span>
    </div>
  </div>
</template>

<script>
import CustomChip from '@/modules/industria/ofertas-trade/views/components/offer-schedule-list/CustomChip.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'CashbackAbsoluteMechanic',
  components: {
    CustomChip,
  },
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cashbackDiscount() {
      return localeString(this.offer.cashback_absolute_discount || this.offer.cashback_absolute, 0)
    },
  },
}
</script>

<style lang="scss" scoped>
.format-information {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;

  @media screen and (max-width: $xs-breakpoint) {
    align-items: center;
    gap: 8px;
  }

  .qty-per-client-text {
    color: $cinza-0;
    font-size: 14px;
    margin-right: 6px;
  }
}
</style>
